import { fragments } from '@/gql'
import gql from 'graphql-tag'
export default gql`
    query CompanyNames($value: Value!) {
      CompanyNames(value: $value, op: "ilike", sortFields: "name", valueKey: "name") {
        ...companyNameDetail
      }
    }
    ${fragments.companyNameDetail}
  `
